export default __webpack_public_path__ + "static/src/assets/images/icons/nav_icon_cashmanage_normal.png";